module.exports = __webpack_public_path__ + "static/media/ad.472f8c6d.svg";